import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { type ButtonSize, type ButtonVariant, buttonClasses } from './button'
import { Tooltip } from './tooltip'

export interface IconButtonProps extends Omit<ComponentProps<'button'>, 'children'> {
  /** Accessible name; also shown as the tooltip. */
  label: string
  icon: ReactNode
  variant?: ButtonVariant
  size?: ButtonSize
  tooltip?: boolean
  shortcut?: string
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left'
}

export function IconButton({
  label,
  icon,
  variant = 'ghost',
  size = 'md',
  tooltip = true,
  shortcut,
  tooltipSide,
  className,
  type,
  ...props
}: IconButtonProps) {
  const button = (
    <button
      type={type ?? 'button'}
      aria-label={label}
      className={buttonClasses(
        variant,
        size,
        cn(size === 'md' ? 'size-(--control-h)' : 'size-7', 'px-0', className),
      )}
      {...props}
    >
      {icon}
    </button>
  )
  return (
    <Tooltip content={label} shortcut={shortcut} disabled={!tooltip} side={tooltipSide}>
      {button}
    </Tooltip>
  )
}
